import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import pledgeBg from "@/assets/restore/pledge-watermark.webp";

const QuoteForm = lazy(() =>
  import("@/components/site/QuoteForm").then((m) => ({ default: m.QuoteForm })),
);

const TITLE = "The RESTORE® Pledge | Satisfaction Guarantee";
const DESCRIPTION =
  "RESTORE® Satisfaction Guarantee: if you are not happy with your results, we perform an added procedure of 25% of your paid grafts at no cost.";
const URL = "https://restorehair.com/restore-pledge/";

const conditions = [
  "Satisfaction Guarantee procedure (SGP) must take place between 12 and 18 months following the previous unsatisfied procedure.",
  "The area to be worked on in the SGP must be an area that was worked in during the unsatisfied procedure and the number of grafts performed shall be proportionate to what was done in that area previously.",
  "The patient must have done the recommended number of grafts in the previous procedure to qualify for a SGP.",
  "SGP must be approved by Restore physician and follow their medical guidelines and restrictions.",
  "Patient must have an acceptable and sufficient amount of donor hair remaining to perform the SGP.",
];

export const Route = createFileRoute("/restore-pledge")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: RestorePledgePage,
});

function RestorePledgePage() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <section className="relative overflow-hidden bg-white py-24 md:py-32">
          <img
            src={pledgeBg}
            alt=""
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 h-full w-full select-none object-cover object-center"
          />

          <div className="relative z-10 mx-auto max-w-4xl px-4 lg:px-8">

            <h1 className="text-center text-3xl font-extrabold uppercase tracking-tight text-foreground md:text-5xl">
              The RESTORE<sup className="text-base align-super">®</sup> Pledge
            </h1>

            <h2 className="mt-10 text-xl font-bold text-foreground md:text-2xl">
              The RESTORE® Satisfaction Guarantee.
            </h2>
            <div className="mt-5 space-y-5 text-base leading-relaxed text-muted-foreground">
              <p>
                At Restore, we stand by our Results. If for any reason you are not happy with the
                results of your RESTORE procedure, we will perform an additional procedure of 25% of
                the number of grafts that you paid for on your previous procedure, all at no cost to
                you.
              </p>
              <p className="font-semibold text-foreground">The following conditions apply:</p>
              <ul className="list-disc space-y-3 pl-6">
                {conditions.map((c) => (
                  <li key={c}>{c}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <Suspense fallback={null}>
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}